import {
  // Flex,
  // InfoItemContainer,
  SectionIconButton,
} from '@equifinance/shared';
import styled, { css } from 'styled-components';
import { StaticDataItem } from '../../../../../api/useAccountApi';
import {
  Applicant,
} from '../../../../../contexts/account/Account';
import EmploymentHistorySection from './EmploymentHistorySection';
import NonJobIncomeSection from './NonJobIncomeSection';
import { PaddedSection } from '../../../components/Section';
import { useAccountContext } from '../../../../../contexts/account';
import { EquifaxAccordionHeaderShadow } from '../../../../Credit/CreditDetails/CreditDetails';

// const Info = styled.div`${({ theme }) => `
//   border-radius: ${theme.borderRadius[2]};
//   box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);

//   ${InfoItemContainer} {
//     margin: 0;
//   }

//   a {
//     text-decoration: none;
//     color: ${theme.textPrimary};
//   }
// `}`;

// const InfoContainer = styled(Flex)`${({ theme }) => `
//   justify-content: space-between;
//   min-height: ${theme.padding[6]};
//   align-items: stretch;
//   line-height ${theme.padding[6]};
// `}`;

const SectionShadow = styled(EquifaxAccordionHeaderShadow)`${({ theme }) => `
  top: -${theme.padding[4]};
  background: linear-gradient(180deg, ${theme.colours.neutral[7]} 0%, ${theme.colours.neutral[9]} 100%);
  left: 0;
`}`;

const bodyCss = css`${({ theme }) => `
  position: relative;
  background: ${theme.colours.neutral[9]};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
`}`;

export const ineSectionBodyCss = css`${({ theme }) => `
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
    
  ${SectionIconButton} {
    :not([disabled]) {
      color: ${theme.colours.primary[1]};
      :hover {
        transform: none;
      }
    }
  }
`}`;

export const ineSectionTitleCss = css`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
`}`;

export const ineSectionHeaderCss = css`${({ theme }) => `
  background: ${theme.colours.primary[3]};
  
  .mi-chevron-up, .mi-chevron-down {
    color: ${theme.colours.neutral[10]};
  }
`}`;

export const ineSubSectionHeaderCss = css`${({ theme }) => `
  background: ${theme.colours.tertiary[6]};
  padding: ${theme.padding[1]} ${theme.padding[4]} ${theme.padding[1]} ${theme.padding[2]} ;
`}`;

export default function IncomeAndEmploymentSection({
  applicant,
  applicantIndex,
  ukCountries,
  accountancyQualifications,
  industries,
  jobTitles,
}: {
    applicant: Applicant,
    applicantIndex: number,
    ukCountries: StaticDataItem[],
    accountancyQualifications: StaticDataItem[],
    industries: StaticDataItem[],
    jobTitles: StaticDataItem[],
  }) {
  const {
    account,
  } = useAccountContext();

  const { errors, warnings } = account ?? {};
  return (
    <PaddedSection
      id={applicant?.incomeAndEmployment?.id}
      title="Income and Employment"
      level={1}
      errors={errors}
      warnings={warnings}
      bodyCss={bodyCss}
      titleIcon={<></>}
    >
      <SectionShadow />
      {/* <Info>
        <SVGInfo>
          <InfoContainer>
            For additional information on providing Income and Employment details please see our help page.
            <Link to={`/application/${account.id}/income-employment-detail/${applicant.id}`} target="_blank">
              <InfoListItemAction>
                <Icon className="mi-circle-arrow-right" />
                Go to page
              </InfoListItemAction>
            </Link>
          </InfoContainer>
        </SVGInfo>
      </Info> */}
      <EmploymentHistorySection
        applicant={applicant}
        applicantIndex={applicantIndex}
        ukCountries={ukCountries}
        accountancyQualifications={accountancyQualifications}
        industries={industries}
        jobTitles={jobTitles}
      />
      <NonJobIncomeSection
        applicant={applicant}
        applicantIndex={applicantIndex}
      />
    </PaddedSection>
  );
}
